import { Link } from "react-router-dom";

const heroBg =
  "https://readdy.ai/api/search-image?query=cinematic%20anime%20illustration%20of%20a%20lone%20student%20walking%20through%20a%20night%20campus%20under%20warm%20orange%20streetlights%2C%20large%20areas%20of%20deep%20warm%20brown%20and%20dark%20shadow%20for%20text%20contrast%2C%20ink%20wash%20and%20sakuga%20style%2C%20golden%20bokeh%20lighting%2C%20atmospheric%20manga%20aesthetic%2C%20clean%20cinematic%20composition%20with%20soft%20motion%20lines&width=1600&height=900&seq=anime-hero-bg&orientation=landscape";

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt="秘密教学动漫夜色下的校园主角剪影"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 md:px-6 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-4 py-1.5 text-sm font-medium text-background-50">
          <i className="ri-fire-fill"></i>
          全网最全剧情解析 · 持续更新
        </span>
        <h1 className="font-heading mt-6 text-3xl text-background-50 md:text-5xl">
          一次看懂《秘密教学动漫》
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-background-100 md:text-lg">
          剧情主线、分集介绍、角色图鉴与结局彩蛋，全部为你整理成一份清单。
          想快速理解每一话的伏笔与细节，从这里开始就好。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/episodes"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto cursor-pointer"
          >
            查看分集介绍
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <a
            href="#story"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-300/70 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto cursor-pointer"
          >
            了解剧情概览
          </a>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 hidden -translate-x-1/2 text-background-200 md:block">
        <i className="ri-arrow-down-s-line text-2xl"></i>
      </div>
    </section>
  );
}